import logger from 'redux-logger';

export const FETCH_PATIENTPAYMENTDETAILS_INIT_ACTION =
  'FETCH_PATIENTPAYMENTDETAILS_INIT_ACTION';
export const FETCH_PATIENTPAYMENTDETAILS_SUCCESS_ACTION =
  FETCH_PATIENTPAYMENTDETAILS_INIT_ACTION + '_SUCCESS';
export const FETCH_PATIENTPAYMENTDETAILS_FAIL_ACTION =
  FETCH_PATIENTPAYMENTDETAILS_INIT_ACTION + '_ERROR';

export const FETCH_PATIENTPAYMENTSTATUSCHANGE_INIT_ACTION =
  'FETCH_PATIENTPAYMENTSTATUSCHANGE_INIT_ACTION';
export const FETCH_PATIENTPAYMENTSTATUSCHANGE_SUCCESS_ACTION =
  FETCH_PATIENTPAYMENTSTATUSCHANGE_INIT_ACTION + '_SUCCESS';
export const FETCH_PATIENTPAYMENTSTATUSCHANGE_FAIL_ACTION =
  FETCH_PATIENTPAYMENTSTATUSCHANGE_INIT_ACTION + '_ERROR';

export const FETCH_PATIENT_REFUND_INIT_ACTION =
  'FETCH_PATIENT_REFUND_INIT_ACTION';
export const FETCH_PATIENT_REFUND_SUCCESS_ACTION =
  FETCH_PATIENT_REFUND_INIT_ACTION + '_SUCCESS';
export const FETCH_PATIENT_REFUND_FAIL_ACTION =
  FETCH_PATIENT_REFUND_INIT_ACTION + '_ERROR';

export function PatientPaymentList(value) {
  return {
    type: FETCH_PATIENTPAYMENTDETAILS_INIT_ACTION,
    value: value,
  };
}

export function PatientpaySlectedPage(value) {
  return {
    type: FETCH_PATIENTPAYMENTDETAILS_INIT_ACTION,
    value: value,
  };
}

export function PatientPaymentSelectedPage(value) {
  return {
    type: FETCH_PATIENTPAYMENTDETAILS_INIT_ACTION,
    value: value,
  };
}
export function PatientPaymentStatusChange(value) {
  return {
    type: FETCH_PATIENTPAYMENTSTATUSCHANGE_INIT_ACTION,
    value: value,
  };
}

export function PatientRefundStatusChange(value) {
  console.log('%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%', value);
  return {
    type: FETCH_PATIENT_REFUND_INIT_ACTION,
    value: value,
  };
}
